import { Link } from "react-router-dom";
import { LineReveal, Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";
import { PRODUCTS, BUSINESS } from "../lib/site";

export default function Products() {
  const categories = [...new Set(PRODUCTS.map((p) => p.category))];

  return (
    <div data-testid="products-page" className="pt-28">
      {/* En-tête */}
      <header className="max-w-7xl mx-auto px-6 md:px-12 pt-6 pb-12">
        <p className="kicker text-crust mb-4">La sélection du fournil</p>
        <LineReveal
          as="h1"
          className="font-serif font-light text-charcoal text-5xl sm:text-6xl lg:text-7xl leading-[0.95] tracking-tight"
          lines={["Nos pains &", "viennoiseries"]}
          delay={0.15}
        />
        <Reveal delay={0.6}>
          <p className="mt-6 max-w-xl text-base sm:text-lg text-ash leading-relaxed">
            Tout est fabriqué sur place, chaque jour. La sélection évolue au fil
            des saisons et des fournées — voici l'essentiel de la maison.
          </p>
        </Reveal>
      </header>

      <Marquee items={["Fournées du jour", "Levain naturel", "Beurre AOP", "Sur place à Nantes"]} />

      {/* Grilles par catégorie */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 flex flex-col gap-16 md:gap-20">
        {categories.map((cat) => (
          <section key={cat} data-testid={`category-${cat}`}>
            <div className="flex items-center gap-6 mb-8">
              <h2 className="font-serif text-3xl sm:text-4xl text-charcoal">{cat}</h2>
              <span className="flex-1 h-px bg-crustborder" />
            </div>
            <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
              {PRODUCTS.filter((p) => p.category === cat).map((p, i) => (
                <Reveal key={p.name} delay={i * 0.05}>
                  <article data-testid={`product-${p.name}`} className="group">
                    <div className="overflow-hidden aspect-[4/5] w-full mb-4">
                      <img
                        src={p.image}
                        alt={p.name}
                        className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                      />
                    </div>
                    <h3 className="font-serif text-2xl sm:text-3xl text-charcoal">{p.name}</h3>
                    <p className="mt-2 text-sm text-ash leading-relaxed">{p.desc}</p>
                  </article>
                </Reveal>
              ))}
            </div>
          </section>
        ))}
      </div>

      {/* Appel à l'action commande */}
      <section className="grain bg-dough border-y border-crustborder">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20 text-center flex flex-col items-center">
          <Reveal>
            <h2 className="font-serif text-5xl sm:text-6xl text-charcoal leading-tight max-w-2xl">
              Une commande particulière&nbsp;?
            </h2>
            <p className="mt-6 max-w-lg text-base sm:text-lg text-ash leading-relaxed">
              Grands formats, pains spéciaux, plateaux pour vos réceptions.
              Parlez-nous de votre envie, nous préparons tout.
            </p>
            <div className="mt-10 flex flex-wrap gap-4 justify-center">
              <Link
                to="/contact"
                data-testid="products-contact-cta"
                className="kicker bg-crust text-cream px-8 py-4 transition-transform duration-200 active:scale-95 hover:bg-crustdark"
              >
                Passer commande
              </Link>
              <a
                href={BUSINESS.phoneLink}
                data-testid="products-phone-cta"
                className="kicker text-charcoal border border-charcoal/30 px-8 py-4 transition-colors duration-300 hover:border-crust hover:text-crust"
              >
                Appeler la boulangerie
              </a>
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
